export const REGEX = {
  only_chars_and_numbers: /^[a-zA-Z0-9]*$/,
  two_decimals: /^\d+(()|(\.\d{0,2})?)$/,
  no_special_chars_or_spaces: /[[\]()<>'\s+"/;_`%#]/,
  no_special_chars: /[[\]()<>'+"/;`%#]/,
  no_double_quote_pipe: /^[^"|]+$/,
  number_only_range_1_12: /(^0?[1-9]$)|(^1[0-2]$)/,
  number_only_range_0_59: /^[0-5]?[0-9]$/,
  no_repeating_chars: /^(?:(.)(?!\1))*$/i, // `/i` modifier will compare case-insenstive values. (aa, Aa, AA)
  HHMM: /^(1[0-2]|0?[1-9]):([0-5][0-9])/,
  HHMMPP: /\b((1[0-2]|0?[1-9]):([0-5][0-9]) ([AaPp][Mm]))/,
  DASH: /-/g,
  DASH_WITH_SPACES: / - /g,
  COLON: /:/g,
  COMMA: /,/g,
  PIPE: /\|/g,
  EMAIL:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  SPACE_COMMA_FILTER: /[, ]+/,
  CREDIT_CARD: /^\d{13,19}$/, // Credit cards have a min of 13 and a max of 19 digits.
  BANK_ACCOUNT_NUMBER: /^\d{6,17}$/, // US Bank account numbers have a min of 6 and a max of 17 digits.
  IS_BASE64: /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?$/,
  IS_IOS: /(iPad|iPhone|iPod)/g,
  REPLACE_LINEBREAK: /(?:\r\n|\r|\n)/g,
  REPLACE_BR: /<br\s*[/]?>/gi,
  IS_PDF: /.pdf/g,
  PERIOD: /\./g,
  REMOVE_HTML_FORMATTING: /<.+?>.*<\/.+>/
};
